<script setup lang="ts">
import { Editor } from "@tiptap/vue-3";
import PlusIcon from "@/components/icon/PlusIcon.vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    editor: Editor;
  }>(),
  {
    disabled: false,
  }
);

const onAddEmptyParagraph = () => {
  const { to } = props.editor.state.selection;
  props.editor.chain().insertContentAt(to, { type: "paragraph" }).focus().run();
};
</script>
<template>
  <button
    class="btn btn-xs md:btn-sm btn-ghost rounded"
    @click="onAddEmptyParagraph"
    :disabled="disabled"
  >
    <plus-icon class="icon-base" />
  </button>
</template>
